/* Надписи на интерфейса, български. Правят се на ръка.
 *
 * Машинен превод без редакция от носител на езика — виж отчета към задачата.
 */

export const ui_bg = {
  // общи, срещат се на няколко екрана
  'ui.common.loading': 'Зареждане...',
  'ui.common.continue': 'Продължи',
  'ui.common.check': 'Провери',
  'ui.common.seeResults': 'Виж резултатите',
  'ui.common.myProgress': 'Моят напредък',
  'ui.common.startTraining': 'Започни обучението',
  'ui.common.min': 'мин',

  // инструктор
  'ui.alisa.name': 'Алиса',
  'ui.alisa.initial': 'А',

  // долна навигация
  'ui.nav.home': 'Начало',
  'ui.nav.modules': 'Модули',
  'ui.nav.progress': 'Напредък',
  'ui.nav.profile': 'Профил',

  // начален екран и запознаване
  'ui.splash.tagline': 'Първият ти ден на пътя',
  'ui.splash.cardTitle': 'Интерактивен тренажор',
  'ui.splash.cardText':
    'Обучавай се с виртуалния инструктор Алиса. Упражнявай реални ситуации на безопасно място и се подготви за първия си работен ден. Отнема само около 5 минути!',
  'ui.splash.start': 'Започни',
  'ui.splash.imAlisa': 'Аз съм Алиса',
  'ui.splash.yourName': 'Как се казваш?',
  'ui.splash.introducePrompt': 'Кажи си името и започваме',
  'ui.splash.namePlaceholder': 'Въведи името си',

  // главен екран
  'ui.home.badgeLine1': 'Първи ден',
  'ui.home.badgeLine2': 'на пътя',
  'ui.home.welcome': 'Добре дошъл,',
  'ui.home.ctaContinue': 'Продължи обучението',
  'ui.home.ctaRetake': 'Повтори обучението',
  'ui.home.ctaStart': 'Започни обучението',
  'ui.home.settings': 'Настройки',
  'ui.home.modulesDone': '{done}/{total} завършени модула',

  // списък с модули
  'ui.modules.title': 'Модули',
  'ui.modules.subtitle': 'Избери тема за обучение',

  // учебен материал
  'ui.learning.notFound': 'Учебният материал не е намерен',
  'ui.learning.label': 'Учебен материал',
  'ui.learning.alisaHint': 'Прочети материала преди теста. Тук е събрано най-важното!',
  'ui.learning.contents': 'Съдържание',
  'ui.learning.doneTitle': 'Материалът е прочетен!',
  'ui.learning.doneSubtitle': 'Сега провери знанията си с интерактивния тест',
  'ui.learning.goToTest': 'Към теста',
  'ui.learning.startTest': 'Започни теста',

  // преминаване на модула
  'ui.module.title': 'Модул 1: {title}',
  'ui.module.notFound': 'Модулът не е намерен',
  'ui.module.leaveConfirm': 'Сигурен ли си, че искаш да излезеш? Напредъкът ще бъде запазен.',
  'ui.module.voiceOn': 'Гласът е включен',
  'ui.module.voiceOff': 'Гласът е изключен',
  'ui.module.voiceUnavailable': 'Гласът не е достъпен в демото',

  // резултати
  'ui.results.moduleComplete': 'Модул „{title}“ е завършен',
  'ui.results.statusExcellent': 'Отлично!',
  'ui.results.statusGood': 'Добре!',
  'ui.results.statusFair': 'Задоволително',
  'ui.results.statusMoreTraining': 'Нужно е още обучение',
  'ui.results.recPerfect':
    'Отлично си подготвен за първия работен ден! Всички отговори са верни. Готов си за пътя!',
  'ui.results.recDecent':
    'Добър резултат! Обърни внимание на грешките и опитай пак, за да затвърдиш материала.',
  'ui.results.recRetake':
    'Препоръчвам да минеш модула отначало. Чети внимателно всяка ситуация и следи подсказките.',
  'ui.results.time': 'Време',
  'ui.results.mistakes': 'Грешки',
  'ui.results.points': 'Точки',
  'ui.results.breakdown': 'Разбивка на точките',
  'ui.results.advice': 'Съветът на Алиса',
  'ui.results.tryAgain': 'Опитай пак',
  'ui.results.backToMenu': 'Обратно към менюто',
  'ui.results.metric.Safety': 'Безопасност',
  'ui.results.metric.Service': 'Обслужване',
  'ui.results.metric.Efficiency': 'Ефективност',
  'ui.results.metric.Professionalism': 'Професионализъм',
  'ui.results.metric.StressResistance': 'Устойчивост на стрес',

  // напредък
  'ui.progress.title': 'Напредък',
  'ui.progress.subtitle': 'Твоите постижения и история на обучението',
  'ui.progress.completed': 'Завършени',
  'ui.progress.totalPoints': 'Общо точки',
  'ui.progress.overall': 'Общ напредък',
  'ui.progress.history': 'История на опитите',
  'ui.progress.empty': 'Още не си завършил нито един модул',
  'ui.progress.unknownModule': 'Неизвестен модул',
  'ui.progress.gradeGreat': 'Отлично',
  'ui.progress.gradeGood': 'Добре',
  'ui.progress.gradeRetake': 'Повтори',
  'ui.progress.pts': 'т.',

  // профил
  'ui.profile.role': 'Куриер стажант',
  'ui.profile.statModules': 'Модули',
  'ui.profile.statTime': 'Време',
  'ui.profile.statBest': 'Рекорд',
  'ui.profile.logout': 'Изход от профила',
  'ui.profile.logoutConfirm': 'Сигурен ли си? Целият напредък ще бъде изтрит.',

  // връзки навън: сайтът на агенцията и запазване на разговор
  'ui.cta.site': 'Направено от BrilliantFlux',
  'ui.cta.booking': 'Запази час за разговор',

  // раздел на браузъра
  'ui.meta.title': 'Delivery Ace | Тренажор',
  'ui.meta.description': 'Интерактивен тренажор за куриери',
};
